<app-create-password-form
  [title]="'recover_password'"
  (submitForm)="restore($event)"
  [success]="success"
>
</app-create-password-form>
